// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from './Modal';
import plural from '../../utilities/plural';
import { toast } from 'react-toastify';
import SelectStack from '../SelectStack';

import '../../styles/move.css';

export default class MoveDocument extends Modal {

    state = {
        root: "",
        children: [],
        hoverIndicator: {},
        selectedStack: ''
    }

    hoverTimeout = {}
    hoverIndicator = {}

    componentDidMount = () => {
        this.setState({selectedStack: this.props.stack._id})
    }

    handleSubmit = (docs) => {
        if(this.props.stack._id === this.state.selectedStack || !this.state.selectedStack)
            return toast.error('You must select a new stack to move documents into')

        this.props.move(docs, this.state.selectedStack)
    }


    renderContent = () => {
        const docs = this.props.data && this.props.data.length > 0 ? this.props.data : [];
        if (docs.length === 0)
            return this.props.modal();

        return (<div
            className={"modal-content modal-center "}
        >
            <h1>{this.props.title ?? "Move your"} {plural("document", docs.length)}</h1>
            <p>
                {this.props.description ?? "Select the stack you'd like to move your " + plural('document', docs.length) + ' to'}
            </p>

            <div style={{ clear: 'both' }} />

            <SelectStack
                value={this.state.selectedStack? this.state.selectedStack: ""}
                onChange={selectedStack => this.setState({selectedStack: selectedStack})}
                stacks={this.props.stacks}
                currentStackId={this.props.stack._id}
            />

            <div style={{ clear: 'both'}} />

            <div
                className="button"
                style={{
                    float: 'none',
                    backgroundImage: "url('https://static.stax.ai/images/icons/reviewed.png')",
                    marginTop: 16
                }}
                onClick={() => this.handleSubmit(docs)}
            >
                {this.props.buttonText ?? "Move"} {plural('document', docs.length)}
            </div>
            
        </div>);
    }

};